import { useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import { Tooltip } from '@bfe/moly';
import { NoSSR } from '@spot-fe/base-ui';

import styles from './index.module.scss';

const AutoEllipsisText = ({ text = '', textClassName = '', maxLine = 1 }) => {
    // 文本元素
    const textRef = useRef<HTMLDivElement>(null);
    const textCopyRef = useRef<HTMLDivElement>(null);
    // 文本是否省略
    const [textEllipsis, settextEllipsis] = useState(false);

    // 处理文本省略计算
    useEffect(() => {
        if (textRef.current && textCopyRef.current) {
            let showMore = false;
            if (maxLine > 1) {
                showMore =
                    textRef.current?.scrollHeight >
                        textRef.current?.clientHeight ||
                    textCopyRef.current?.scrollHeight >
                        textCopyRef.current?.clientHeight;
            } else {
                showMore = 
                    textRef.current?.scrollWidth >
                        textRef.current?.clientWidth ||
                    textCopyRef.current?.scrollWidth >
                        textCopyRef.current?.clientWidth;
            }

            settextEllipsis(showMore);
        }
    }, [textRef.current, textCopyRef.current, maxLine, text]);
    return (
        <>
            <div className={textEllipsis ? '' : styles.hide}>
                <NoSSR>
                    <Tooltip
                        title={text}
                        overlayClassName={styles.tipText}
                        trigger="hover"
                        placement="bottom"
                        hasDashedLine={false}
                    >
                        <div
                            className={cls([
                                styles.text,
                                maxLine !== 1 ? styles.moreLine : '',
                                textClassName,
                            ])}
                            style={{
                                WebkitLineClamp: maxLine,
                            }}
                            ref={textRef}
                        >
                            {text}
                        </div>
                    </Tooltip>
                </NoSSR>
            </div>
            <div className={textEllipsis ? styles.hide : ''}>
                <div
                    className={cls([
                        styles.text,
                        maxLine !== 1 ? styles.moreLine : '',
                        textClassName,
                    ])}
                    style={{
                        WebkitLineClamp: maxLine,
                    }}
                    ref={textCopyRef}
                >
                    {text}
                </div>
            </div>
        </>
    );
};

export default AutoEllipsisText;
